import { ClientRoutes } from "../../../Constants/ClientRoutingConstants";
import { NotificationMetadata } from "../../../Models/Notifications/NotificationReadTableDto";

// Link to the notification's asset dashboard, or null when there's no machineId.
export function getNotificationLink(metadata?: NotificationMetadata): string | null {
  const machineId = metadata?.machineId;
  return machineId ? `${ClientRoutes.AssetsDashboardPage}/${machineId}` : null;
}
